<script>
  import { tick } from "svelte"
  import { onMount, onDestroy } from "svelte"
  import { session, gameId, me, update } from "../store"
  import Shell from "./Shell.svelte"
  export let unit = "s"
  export let pre = false
  export let units = "s"
  let val = false
  let initd = false
  let timo = 0

  $: val = getVal("init")
  function getVal(state = "notinit") {
    if ($session.nextPhase) {
      let v = $session.nextPhase
      if (v > 0) {
        initd = true
      } else {
        v = 0
      }
      return v
    }
    return false
  }
  async function count() {
    val = getVal()
    await tick()
    timo = setTimeout(() => {
      count()
    }, 1000)
  }
  onMount(() => {
    count()
  })
  onDestroy(() => {
    clearTimeout(timo)
  })
</script>

<style lang="scss">
  @import "../vars";
  .invisible {
    opacity: 0 !important;
  }
  .count span {
    opacity: 1;
    transition: all 0.25s;
  }
</style>

<div class="count">
  {#if pre}
    <label>{pre}</label>
  {/if}
  <span class:invisible={!initd}>
    {val ? val : 0}{val === 1 ? unit : units}
  </span>
  {#if !pre}
    <label>remaining</label>
  {/if}
</div>
